import React, {Component} from "react";
import {Grid, Grow, Icon} from "@material-ui/core";
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import ContactForm from './ContactForm/ContactForm';
import profileData from '../../assets/static/profile.json';
import classes from './Contact.module.css';

class Contact extends Component {
	render() {
		let profile = profileData.profile;
		let contacts = profile.contact;
		return (
			<Grow in={true} timeout={1000}>
				<div className={classes.Contact}>
					<h1>Get in Touch</h1>
					<Grid
						spacing={0}
						style={{padding: 0}}
						container>
						<Grid item xs={12} md={6}>
							<ul>
								{
									contacts.map(contact => (
										<li key={contact.id}>
											<div className={classes.ContactCard}>
												<a href={contact.link} target={"_blank"} rel="noopener noreferrer">
													<span className={classes.ContactIcon}>
														{contact.name === 'whatsapp'
															? <WhatsAppIcon style={{fontSize: '30px'}}/>
															: <Icon style={{fontSize: 30}}>{contact.icon}</Icon>
														}
													</span>
													<span className={classes.ContactText}>{contact.text}</span>
												</a>
											</div>
										</li>
									))
								}
							</ul>
						</Grid>
						<Grid item xs={12} md={6}>
							<ContactForm />
						</Grid>
					</Grid>
				</div>
			</Grow>
		)
	}
}

export default Contact;
